/* Titan League - Titan Coins en todas las tiendas.
   10 Titan Coins = $1 MXN. Las monedas son el credito de tienda de Shopify del cliente,
   se aplican en el pago (checkout) de Shopify. */
(function(){
  if(window.__tlCoinsPay){return;} window.__tlCoinsPay=1;
  var T=window.TLC||{in:false,coins:0,login:'/account/login',coin:''};
  var RATE=10;
  var mxnByHandle={};
  var current=null;

  function n(x){return Math.round(x).toLocaleString('es-MX');}
  function coinsOf(mxn){return Math.round(mxn*RATE);}
  function parseMoney(t){
    if(!t){return 0;}
    var m=String(t).replace(/\s/g,'').match(/\$?([\d.,]+)/);
    if(!m){return 0;}
    var s=m[1];
    if(/,\d{2}$/.test(s)&&s.indexOf('.')>=0){s=s.replace(/\./g,'').replace(',','.');}
    else{s=s.replace(/,/g,'');}
    var v=parseFloat(s); return isFinite(v)?v:0;
  }
  function coinImg(cls){
    return T.coin?'<img class="'+cls+'" src="'+T.coin+'" alt="" width="40" height="40" loading="lazy">':'<span class="'+cls+' tlc-dot"></span>';
  }
  function cardMxn(card){
    var h=card.getAttribute('data-handle');
    if(h&&mxnByHandle[h]){return mxnByHandle[h];}
    var st=card.querySelector('.tlf2-price strong');
    var v=st?parseMoney(st.textContent):0;
    if(!v){v=parseFloat(card.getAttribute('data-mxn'))||0;}
    return v;
  }

  /* ---------- estilos ---------- */
  var css=''+
  '.tlc-card{display:flex;align-items:center;gap:7px;margin:-6px 0 13px;padding:6px 10px 6px 6px;border:1px solid rgba(255,207,72,.35);border-radius:999px;background:linear-gradient(90deg,rgba(255,196,40,.16),rgba(255,196,40,.03));color:#ffe9a8;font:800 12px/1.1 Inter,system-ui,sans-serif;width:max-content;max-width:100%}'+
  '.tlc-card .tlc-ic{width:20px;height:20px;flex:0 0 20px;object-fit:contain;filter:drop-shadow(0 0 5px rgba(255,190,50,.55))}'+
  '.tlc-card b{color:#ffd35c;font-size:13.5px;font-weight:950}'+
  '.tlc-card em{font-style:normal;color:#cdb98a;font-weight:700}'+
  '.tlc-dot{display:inline-block;border-radius:50%;background:radial-gradient(circle at 35% 30%,#fff3b0,#f0a52a 60%,#8a5410)}'+
  '.tlc-box{margin:4px 0 16px;padding:14px;border:1px solid rgba(255,207,72,.45);border-radius:15px;background:radial-gradient(circle at 12% 0,rgba(255,200,60,.18),transparent 55%),#120b06;color:#f3e6c4;font-family:Inter,system-ui,sans-serif}'+
  '.tlc-row{display:flex;align-items:center;gap:12px}'+
  '.tlc-row .tlc-ic{width:46px;height:46px;flex:0 0 46px;object-fit:contain;filter:drop-shadow(0 0 10px rgba(255,190,50,.6))}'+
  '.tlc-k{display:block;color:#d9c18a;font-size:11px;font-weight:900;letter-spacing:.12em;text-transform:uppercase}'+
  '.tlc-v{display:block;color:#ffd35c;font-size:26px;font-weight:1000;line-height:1.1}'+
  '.tlc-v small{font-size:13px;color:#f1d98f;font-weight:800;margin-left:4px}'+
  '.tlc-eq{display:block;color:#bfae88;font-size:12px;margin-top:2px}'+
  '.tlc-bal{margin:12px 0 10px;padding:9px 11px;border-radius:11px;background:rgba(255,255,255,.05);font-size:13px;line-height:1.45;color:#e9dcc0}'+
  '.tlc-bal b{color:#ffd35c}'+
  '.tlc-bal .ok{color:#7ef0a6;font-weight:900}'+
  '.tlc-bal .no{color:#ffb86b;font-weight:900}'+
  '.tlc-bal a{color:#ffd35c;font-weight:900;text-decoration:underline}'+
  '.tlc-pay{display:flex;align-items:center;justify-content:center;gap:9px;width:100%;min-height:50px;border:0;border-radius:12px;background:linear-gradient(90deg,#ffe07a,#ffb629 55%,#f08a12);color:#2a1600;font:950 15px/1 Inter,system-ui,sans-serif;cursor:pointer;box-shadow:0 12px 28px rgba(255,170,30,.3);text-decoration:none}'+
  '.tlc-pay:hover{filter:brightness(1.06)}'+
  '.tlc-pay[disabled]{opacity:.6;cursor:wait}'+
  '.tlc-pay .tlc-ic{width:24px;height:24px}'+
  '.tlc-how{margin:9px 0 0;color:#a99a7c;font-size:11.5px;line-height:1.45}'+
  '.tlc-or{display:flex;align-items:center;gap:10px;margin:14px 0 10px;color:#8f8398;font-size:11px;font-weight:900;letter-spacing:.14em}'+
  '.tlc-or:before,.tlc-or:after{content:"";flex:1;height:1px;background:rgba(255,255,255,.12)}'+
  '.tlc-prod{margin:10px 0 4px}'+'.tlc-eqline{margin:-8px 0 16px}'+
  '@media(max-width:520px){.tlc-card{font-size:11px;padding:5px 9px 5px 5px}.tlc-card b{font-size:12.5px}.tlc-card .tlc-ic{width:18px;height:18px;flex-basis:18px}.tlc-v{font-size:22px}.tlc-row .tlc-ic{width:40px;height:40px;flex-basis:40px}}';
  var st=document.createElement('style'); st.id='tlc-style'; st.textContent=css; document.head.appendChild(st);

  /* ---------- tarjetas ---------- */
  function paintCard(card){
    var mxn=cardMxn(card); if(!(mxn>0)){return;}
    var chip=card.querySelector('.tlc-card');
    var price=card.querySelector('.tlf2-price');
    if(!price){return;}
    if(!chip){
      chip=document.createElement('div'); chip.className='tlc-card';
      price.parentNode.insertBefore(chip,price.nextSibling);
    }
    var c=coinsOf(mxn);
    if(chip.getAttribute('data-c')===String(c)){return;}
    chip.setAttribute('data-c',String(c));
    chip.innerHTML=coinImg('tlc-ic')+'<span><em>o</em> <b>'+n(c)+'</b> <em>Titan Coins</em></span>';
    chip.title='Paga con tus Titan Coins: '+n(c)+' monedas';
  }
  function paintAll(){
    Array.prototype.forEach.call(document.querySelectorAll('.tlf2-card'),paintCard);
    paintModal();
  }

  /* ---------- modal de compra ---------- */
  function modalMxn(modal){
    if(current){var v=cardMxn(current); if(v>0){return v;}}
    var el=modal.querySelector('#tlf2-modal-mxn');
    return el?parseMoney(el.textContent):0;
  }
  function paintModal(){
    var modal=document.getElementById('tlf2-modal'); if(!modal){return;}
    var anchor=modal.querySelector('.tlf2-modal-price'), co=modal.querySelector('.tlf2-checkout');
    if(!anchor||!co){return;}
    var eq=modal.querySelector('.tlc-eqline');
    if(!eq){eq=document.createElement('div'); eq.className='tlc-card tlc-eqline'; anchor.parentNode.insertBefore(eq,anchor.nextSibling);}
    var box=modal.querySelector('.tlc-box');
    if(!box){
      box=document.createElement('div'); box.className='tlc-box';
      co.parentNode.insertBefore(box,co);
      box.addEventListener('click',onPay);
    }
    var mxn=modalMxn(modal); if(!(mxn>0)){box.style.display='none';eq.style.display='none';return;}
    box.style.display=''; eq.style.display='';
    var need=coinsOf(mxn), have=T.coins||0;
    var key=need+'|'+have+'|'+(T.in?1:0);
    if(box.getAttribute('data-k')===key){return;}
    box.setAttribute('data-k',key);
    eq.innerHTML=coinImg('tlc-ic')+'<span><em>o</em> <b>'+n(need)+'</b> <em>Titan Coins</em></span>';
    var bal, btn;
    if(!T.in){
      bal='<b>Inicia sesión con tu Cuenta Titan</b> para pagar con tus monedas.';
      btn='<a class="tlc-pay" data-tlc="login" href="'+T.login+'">🔒 Inicia sesión para pagar con monedas</a>';
    }else if(have>=need){
      bal='Tu saldo: <b>'+n(have)+'</b> monedas · <span class="ok">✓ Te alcanza</span> · te quedan <b>'+n(have-need)+'</b>';
      btn='<button class="tlc-pay" type="button" data-tlc="pay">'+coinImg('tlc-ic')+'Pagar con mis Titan Coins</button>';
    }else if(have>0){
      bal='Tu saldo: <b>'+n(have)+'</b> monedas · <span class="no">te faltan '+n(need-have)+'</span> (= $'+n((need-have)/RATE)+' MXN). Usas tus monedas y pagas la diferencia con tarjeta, o <a href="/pages/titan-coins">recarga aquí</a>.';
      btn='<button class="tlc-pay" type="button" data-tlc="pay">'+coinImg('tlc-ic')+'Usar mis monedas + pagar diferencia</button>';
    }else{
      bal='Tu saldo: <b>0</b> monedas. <a href="/pages/titan-coins">Recarga Titan Coins</a> y paga tus compras con ellas.';
      btn='<a class="tlc-pay" href="/pages/titan-coins">'+coinImg('tlc-ic')+'Recargar Titan Coins</a>';
    }
    box.innerHTML=
      '<div class="tlc-row">'+coinImg('tlc-ic')+'<div><span class="tlc-k">Paga con Titan Coins</span>'+
      '<span class="tlc-v">'+n(need)+'<small>monedas</small></span>'+
      '<span class="tlc-eq">$'+n(mxn)+' MXN × 10 = '+n(need)+' monedas</span></div></div>'+
      '<div class="tlc-bal">'+bal+'</div>'+btn+
      (T.in&&have>0?'<p class="tlc-how">En la pasarela de pago toca <b>“Pagar con Titan Coins en la tienda”</b> y se descuenta de tu cartera.</p>':'')+
      '<div class="tlc-or">O PAGA CON TARJETA</div>';
  }
  function onPay(e){
    var b=e.target.closest&&e.target.closest('[data-tlc]'); if(!b){return;}
    var modal=document.getElementById('tlf2-modal');
    if(b.getAttribute('data-tlc')==='login'){
      e.preventDefault();
      location.href=T.login+(T.login.indexOf('?')>=0?'&':'?')+'return_url='+encodeURIComponent(location.pathname);
      return;
    }
    e.preventDefault();
    var co=modal&&modal.querySelector('.tlf2-checkout'); if(!co){return;}
    var uu=modal.querySelector('#tlf2-username'), cc=modal.querySelector('#tlf2-confirm');
    if((uu&&uu.value.trim().length<3)||(cc&&!cc.checked)){ co.click(); if(uu){uu.scrollIntoView({block:'center',behavior:'smooth'});} return; }
    b.disabled=true;
    /* compra directa con monedas: el carrito solo lleva este articulo */
    fetch('/cart/clear.js',{method:'POST',headers:{'Accept':'application/json'}})['catch'](function(){})
    .then(function(){ return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({attributes:{'Pago con':'Titan Coins'}})}); })
      ['catch'](function(){})
      .then(function(){ b.disabled=false; co.click();
        setTimeout(function(){var sEl=modal.querySelector('.tlf2-status'),u=modal.querySelector('#tlf2-username');
          if(sEl&&sEl.textContent&&!co.disabled&&u){u.scrollIntoView({block:'center',behavior:'smooth'});}},250); });
  }

  /* ---------- pagina de producto ---------- */
  function paintProduct(){
    if(!T.product){return;}
    var price=document.querySelector('.product__info-container .price, .product__info-wrapper .price, [id^="price-template"] .price');
    if(!price){return;}
    var last=price.querySelector('.price__sale .price-item--sale');
    var onSale=price.classList.contains('price--on-sale');
    var el=onSale&&last?last:price.querySelector('.price__regular .price-item--regular')||price.querySelector('.price-item');
    var mxn=el?parseMoney(el.textContent):T.product/100;
    if(!(mxn>0)){return;}
    var holder=price.parentNode, chip=holder.querySelector('.tlc-card.tlc-prod');
    if(!chip){chip=document.createElement('a');chip.className='tlc-card tlc-prod';chip.href=T.in?'/pages/cartera':'/pages/titan-coins';price.parentNode.insertBefore(chip,price.nextSibling);}
    var c=coinsOf(mxn);
    if(chip.getAttribute('data-c')===String(c)){return;}
    chip.setAttribute('data-c',String(c));
    chip.innerHTML=coinImg('tlc-ic')+'<span><em>o paga con</em> <b>'+n(c)+'</b> <em>Titan Coins'+(T.in?' · tienes '+n(T.coins||0):'')+'</em></span>';
    chip.style.textDecoration='none';
  }

  /* ---------- arranque ---------- */
  document.addEventListener('click',function(e){
    if(e.isTrusted&&e.target&&e.target.closest&&e.target.closest('.tlf2-checkout')){
      fetch('/cart/update.js',{method:'POST',keepalive:true,headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{'Pago con':''}})})['catch'](function(){});
    }
    var c=e.target&&e.target.closest&&e.target.closest('.tlf2-card');
    if(c){current=c; setTimeout(paintModal,30); setTimeout(paintModal,300);}
  },true);
  var queued=false;
  function schedule(){ if(queued){return;} queued=true; setTimeout(function(){queued=false; paintAll(); paintProduct();},350); }
  function boot(){
    paintAll(); paintProduct();
    fetch('/products.json?limit=250',{cache:'no-store'}).then(function(r){return r.json();}).then(function(d){
      (d.products||[]).forEach(function(p){ if(p.variants&&p.variants[0]){ var v=parseFloat(p.variants[0].price); if(v>0){mxnByHandle[p.handle]=v;} } });
      Array.prototype.forEach.call(document.querySelectorAll('.tlc-card'),function(x){x.removeAttribute('data-c');});
      var bx=document.querySelector('.tlc-box'); if(bx){bx.removeAttribute('data-k');}
      paintAll();
    })['catch'](function(){});
    try{
      new MutationObserver(function(ms){
        for(var i=0;i<ms.length;i++){var t=ms[i].target; if(t&&t.closest&&!t.closest('.tlc-card,.tlc-box,.tlc-eqline')){schedule();return;}}
      }).observe(document.body,{subtree:true,childList:true,characterData:true});
    }catch(err){}
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();
